export const createTask = (payload?: any) => ({
    type: "@saga/CREATE_TASK",
    payload
});

